export default {
  dashboardv2: {
    usersByStatus: "Gebruikers per Status",
    allTime: "Altijd",
    noOfUsers: "Aantal Gebruikers",
    usersByGender: "Gebruikers per Geslacht",
    gender: "Geslacht",
    farmerName: "Naam van Boer",
    farmerProduction: "Boerenproductie",
    production: "Productie",
    plan: "Plan",
    expiryDate: "Vervaldatum",
    buyingStationProduction: "Productie van het Koopstation",
    dryMillingProduction: "Productie van Droge Maling",
    usersPerMembershipPlans: "Gebruikers per Lidmaatschapsplannen",
    planType: "Plantoype",
    users: "Gebruikers",
    planValidity: "Plangeldigheid",
    averageSellingPriceByAllFarmers: "Gemiddelde Verkoopprijs door Alle Boeren",
    avgSellingPrice: "Gem. Verkoopprijs",
    pricePaid: "Prijs Betaald",
    avgSellingPricePerFarmer: "Gemiddelde Verkoopprijs per Boer",
    exportAsCSV: "Exporteren als CSV",
    exportAsXLS: "Exporteren als XLS",
  },
  dashboardSection: {
    greenBeansData: "Beheer van groene bonen",
    greenCoffee: "Groene Koffie",
    dryMilling: "Droge maling",
    modules: "Modules",
    allowances: "Toelagen",
    maxUserAllowed: "Maximaal toegestane gebruikers",
    satelliteReportsAllowed: "Toegestane satellietrapporten ",
    advanceReport: "Toegestane geavanceerde rapporten",
    subscriptionUpTo: "Abonnement tot",
    roleAllowed: "Toegestane rollen ",
    moduleAllowed: "Toegestane modules ",
    registeredUsers: "Geregistreerde gebruikers",
    validMemberships: "Geldige lidmaatschappen",
    activeUsers: "Actieve gebruikers",
    deactivatedUsers: "Gedeactiveerde gebruikers",
    membershipValidity: "Geldigheid van lidmaatschap",
    lessThan1Month: "Minder dan 1 maand",
    months1to6: "1-6 maanden",
    months6to12: "6-12 maanden",
    moreThan1Year: "Meer dan 1 jaar ",
    cropOverview: "Overzicht van gewassen",
    plantations: "Plantages ",
    coffeeData: "Koffiegegevens",
    availableModules: "Beschikbare modules",
    roleList: "Boer, inkoopcentrum, magazijn",
    memberData: "Gegevens van lid",
    userType: "Type gebruiker",
    registered: "Geregistreerd",
    offlineUsers: "Offline gebruikers",
    lessThanOneMonth: "< 1 Maand",
    cacaoData: "Cacaogegevens",
    dryCacao: "Droge Cacao",
    traceability: "Traceerbaarheid",
  },
  greenBeansData: {
    notFound: "Geen gegevens gevonden",
  },
  dashboardReports: {
    appDataReports: "Applicatiegegevensrapporten",
    reports: "Rapporten",
  },
};
